module.exports = __webpack_public_path__ + "static/media/header_album_wakatsuki911e3476260e80f28f182bf39fc93bc7.webp";